<template>
  <div class="bread">
    <!-- <el-breadcrumb separator="/">
              <el-breadcrumb-item v-for="route in $route.matched" :to="route.path" :key="route.path">{{
                route.meta.name }}
              </el-breadcrumb-item>
            </el-breadcrumb> -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>游利社</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.meta.name}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  name: "bread-crumb",
  data() {
    return {};
  },
  mounted() {
  },
}
</script>

<style lang="scss" type="text/scss" scoped>
.bread {
  height: 45px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/bread-crumb.vue